import { __require as s } from "./_baseFindIndex.js";
import { __require as x } from "./_baseIteratee.js";
import { __require as I } from "./toInteger.js";
var n, a;
function b() {
  if (a) return n;
  a = 1;
  var u = s(), d = x(), _ = I(), o = Math.max;
  function f(r, q, i) {
    var t = r == null ? 0 : r.length;
    if (!t)
      return -1;
    var e = i == null ? 0 : _(i);
    return e < 0 && (e = o(t + e, 0)), u(r, d(q, 3), e);
  }
  return n = f, n;
}
export {
  b as __require
};
